const KB = 1024;
const MB = KB * 1024;

/**
 * Tamaño legible de un archivo: "850 KB", "2.4 MB".
 * `empty` se devuelve cuando no hay tamaño (0, null o undefined).
 */
export const formatFileSize = (size, { empty = "-" } = {}) => {
  const bytes = Number(size || 0);
  if (bytes <= 0) return empty;
  if (bytes < MB) return `${Math.max(1, Math.round(bytes / KB))} KB`;
  return `${(bytes / MB).toFixed(1)} MB`;
};

export const isPdfFile = (type = "", name = "") =>
  type === "application/pdf" || /\.pdf$/i.test(name);

export const isImageFile = (type = "", name = "") =>
  type.startsWith("image/") || /\.(jpe?g|png|gif|webp)$/i.test(name);
